import { formatPhone } from './format-phone';

import type { CountryCode } from 'src/constants';

export const getPhoneToApi = (phone: string, countryCode: CountryCode) =>
  `+${formatPhone(phone, countryCode)}`;
